import { useEffect } from 'react';

import { supabase } from '../supabaseClient';

export function useAuthSession({
  loadProfile,
  setAuthLoading,
  setIsRecovery,
  setProfile,
  setRecoveryType,
  setSession,
}) {
  useEffect(() => {
    // Lien d'invitation ou de réinitialisation : on force l'écran "définir mot de passe"
    const hash = window.location.hash || '';
    const search = window.location.search || '';
    if (hash.includes('type=invite') || hash.includes('type=recovery')) {
      setIsRecovery(true);
      // 'welcome=1' (1ère invitation) ou type=invite → écran de bienvenue ; sinon réinitialisation
      setRecoveryType(
        hash.includes('type=invite') || search.includes('welcome=1') ? 'invite' : 'recovery',
      );
    }

    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      if (session) loadProfile(session.user.id);
      else setAuthLoading(false);
    });
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_e, s) => {
      if (_e === 'PASSWORD_RECOVERY') setIsRecovery(true);
      setSession(s);
      // La session de départ est déjà chargée par getSession ci-dessus, et un renouvellement de
      // jeton ne change pas l'utilisateur : recharger ici doublait toutes les requêtes.
      if (_e === 'INITIAL_SESSION' || _e === 'TOKEN_REFRESHED') return;
      if (s) loadProfile(s.user.id);
      else {
        setProfile(null);
        setAuthLoading(false);
      }
    });
    return () => subscription.unsubscribe();
  }, []);
}
